import React from 'react';

export const ArrowDownFillIcon = ({ className }) => (
  <svg className={className} height="30px" fill="white" viewBox="0 0 24 24">
    <path d="M7 10l5 5 5-5z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);
